import React from 'react';
import PropTypes from 'prop-types';
import features from 'lib/common/features';
import summaryTitle from 'lib/seats/summaryTitle';

const SeatView = ({ seatView }) => {
  return (
    <div className="syos-seatview">
      <div className="syos-seatview__image">
        <img src={seatView.image} />
      </div>
      {features.getOption('viewFromSeat', 'showCaption') === true && (
        <div className="syos-seatview__caption">
          Showing sample view for: {summaryTitle(seatView.data)}
        </div>
      )}
    </div>
  );
};
SeatView.propTypes = {
  seatView: PropTypes.object
};

export default SeatView;



// WEBPACK FOOTER //
// ./src/javascripts/components/SeatView.js